// @ts-ignore
import { FetchWithAuth } from "digimaker-ui/util";

export const fetchImages = async (ids: string) => {
  const data = await FetchWithAuth("content/list/image?limit=-1&cid=" + ids);
  const list: Array<string> = [];
  for (const item of data.data.list) {
    list.push(item.image);
  }
  return list;
};
